/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateUserIntent} from '../api'

export const useMutationUpdateUserIntent = createReactQueryMutationHook('updateUserIntent', updateUserIntent)
